// src/components/Captcha/GoogleCaptcha.jsx
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Box, Typography, Button, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { NAVY } from "../../colors";

export default function GoogleCaptcha({ onSuccess, handleClose }) {
  const [verified, setVerified] = useState(false);
  const [msg, setMsg] = useState(null);

  // ✅ Your Google reCAPTCHA SITE KEY (déjà mis)
  const siteKey = "6LcxoQ8sAAAAAAogHVFVLyQ6M0ouFV93iYF3URNh";

  const onChange = (value) => {
    if (value) {
      setVerified(true);
      setMsg({ type: "success", text: "Vérification réussie !" });
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000,
      }}
    >
      <Box
        sx={{
          background: "#fff",
          padding: 4,
          borderRadius: 2,
          width: "90%",
          maxWidth: 450,
          textAlign: "center",
          border: `2px solid ${NAVY}`,
          position: "relative",
        }}
      >
        {/* CLOSE BUTTON */}
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            cursor: "pointer",
            color: NAVY,
          }}
        />

        {/* TITLE */}
        <Typography variant="h6" sx={{ fontWeight: "bold", color: NAVY, mb: 2 }}>
          Vérification anti-robot
        </Typography>

        {/* GOOGLE CAPTCHA */}
        <ReCAPTCHA sitekey={siteKey} onChange={onChange} />

        {/* MESSAGE */}
        {msg && (
          <Alert severity={msg.type} sx={{ mt: 2 }}>
            {msg.text}
          </Alert>
        )}

        {/* VALIDATION BUTTON */}
        <Button
          variant="contained"
          disabled={!verified}
          onClick={onSuccess}
          sx={{
            mt: 3,
            backgroundColor: NAVY,
            fontWeight: "bold",
            width: "200px",
            borderRadius: "6px",
          }}
        >
          Continuer
        </Button>
      </Box>
    </Box>
  );
}
